(function ($) {
  'use strict';

  /*
   * Replace all the type buttons with a button type submit
   */
   // console.log($('#nf-field-12'));
   $(document).ready(function () {
     // console.log($('#nf-field-12').length);
   });
   $('input[type="button"], input[type="submit"]').each(function () {
     var $this = $(this);
     // console.log($this);
     var button = '<button'+ ( $this.attr('type') === 'button' ? ' type="submit"' : '' ) +'>' + $this.val() + '</button>';
     $this.after(button);
   });
}(jQuery));
